export default "__VITE_ASSET__DaY3dVx0__"